import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // fetchBanner: null,
  // fetchBannerStart: null,
  // fetchBannerSuccess: ['bannerData'],
  // fetchBannerFailure: null,

  fetchTopResults: ['query', 'pageNumber'],
  fetchTopResultsStart: null,
  fetchTopResultsSuccess: ['topResults'],
  fetchTopResultsFailure: null,

  // fetchTrendingTags: null,
  // fetchTrendingTagsStart: null,
  // fetchTrendingTagsSuccess: ['trendingTags'],
  // fetchTrendingTagsFailure: null,

  fetchTopReviewsForSearch: null,
  fetchTopReviewsForSearchStart: null,
  fetchTopReviewsForSearchSuccess: ['topReviewsForSearch'],
  fetchTopReviewsForSearchFailure: null

  // increasePostCount: ['postId']
  // increasePostCountStart: null,
  // increasePostCountSuccess: ['topNews'],
  // increasePostCountFailure: null,
});

export { Types, Creators };
